module.exports = __webpack_public_path__ + "static/media/canon.65f1b6de.svg";